module.exports = __webpack_public_path__ + "img/bg2.6f317450.png";